import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const ListAndImageBase = styled.div``;

export const Title = styled.h2``;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: auto;
  align-items: center;

  ${theme.largerThan.lg} {
    flex-direction: row;
    align-items: initial;
  }
`;

export const Image = styled.img`
  object-fit: cover;
  width: 100%;
  border-radius: ${theme.borderRadius};

  /* Only show on desktop */
  display: none;

  ${theme.largerThan.lg} {
    display: block;
    max-width: 486px;
    max-height: 486px;
    margin-right: 24px;
    margin-bottom: 0;
  }
`;

export const List = styled.div`
  ${theme.largerThan.lg} {
    height: fit-content;
    max-height: 486px;
  }
`;

export const Entry = styled.div``;
